module.exports = __webpack_public_path__ + "img/main-3.30200109.svg";